<template>
    <div>
        <h4 class="pl-2 pt-1">{{ heading }}</h4>
        <section class="table-section">
            <table class="table css-table widget-table table-fixed">
                <thead>
                    <tr>
                        <th class="cw-toggle"></th>
                        <th class="cw-16">Date</th>
                        <th>Bank Account</th>
                        <th class="cw-12 text-right">Amount</th>
                    </tr>
                </thead>
                <tbody v-for="account in accounts" :key="account.key">
                    <tr>
                        <td class="cw-toggle position-relative">
                            <a href v-if="account.buckets && account.buckets.length" class="widget-toggle-wrapper collapse-trigger" role="button" :class="{'is-expanded': isExpanded(account.key)}" @click.prevent="toggle(account.key)">
                                <collapse-toggle-button/>
                            </a>
                        </td>
                        <td>{{ $filters.date(checkDate) }}</td>
                        <td>{{ account.name }}</td>
                        <td class="text-right">${{ account.amount }}</td>
                    </tr>
                    <tr v-for="bucket in visibleBuckets(account)" v-show="isExpanded(account.key)" :key="account.key + '/' + bucket.key" class="no-transition">
                        <td class="cw-toggle"></td>
                        <td></td>
                        <td class="table-indent-1">{{ bucket.name }}</td>
                        <td class="text-right">${{ bucket.amount }}</td>
                    </tr>
                </tbody>
                <tbody v-if="!accounts.length">
                    <tr>
                        <td class="cw-toggle"></td>
                        <td colspan="3" class="text-muted">{{ emptyMessage }}</td>
                    </tr>
                </tbody>
            </table>
        </section>
        <div class="cash-requirements-total d-flex justify-content-between pt-2 pb-2 pl-2 pr-2 mt-1">
            <h4 class="mb-0">Total {{ heading }}</h4>
            <h4 class="mb-0">${{ total }}</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CashRequirementsSection',
    props: ['heading', 'accounts', 'checkDate', 'emptyMessage'],
    data() {
        return {
            // Per-account row expansion state, keyed by account.key.
            expandedAccounts: {},
        }
    },
    computed: {
        total() {
            const sum = (this.accounts || []).reduce((acc, account) => acc + (parseFloat(account.amount) || 0), 0)
            return sum.toFixed(2)
        },
    },
    methods: {
        // Third-Party Payments aren't funded yet (always $0.00), so hide that line unless it
        // carries an amount. Other buckets always show, even at $0.
        visibleBuckets(account) {
            return (account.buckets || []).filter(bucket => {
                if (bucket.key === 'third-party-payments' && parseFloat(bucket.amount) === 0) {
                    return false
                }
                return true
            })
        },
        isExpanded(accountKey) {
            return !!this.expandedAccounts[accountKey]
        },
        toggle(accountKey) {
            this.expandedAccounts[accountKey] = !this.expandedAccounts[accountKey]
        },
    },
}
</script>

<style scoped lang="scss">
.table-indent-1 {
    padding-left: 2rem !important;
}
.cash-requirements-total {
    background-color: #F7F7F7;
    border: 2px solid #ccc;
}
</style>
